import { t } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className="pt-[140px]">
      <div className="flex justify-center items-center px-4 py-12 bg-gray-50 sm:px-6 lg:px-8">
        <div className="space-y-8 w-full max-w-md text-center">
          <div className="animate-pulse">
            <h1 className="text-9xl font-extrabold text-gray-600">404</h1>
          </div>
          <div className="space-y-4 animate-pulse">
            <h2 className="mt-6 text-3xl font-bold text-gray-900">
            {t('errors.not_found')}
            </h2>
            <p className="text-gray-600 animate-pulse">
              {t('errors.not_found_message')}
            </p>
          </div>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 mt-8 text-base font-medium text-white bg-gray-600 rounded-md border border-transparent transition-colors duration-300 ease-in-out animate-pulse hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            {t('errors.go_home')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error404;
